__turbopack_context__.v({
  "backless": "Button-module__bRpT2W__backless",
  "grey": "Button-module__bRpT2W__grey",
  "icon-append": "Button-module__bRpT2W__icon-append",
  "icon-prepend": "Button-module__bRpT2W__icon-prepend",
  "large": "Button-module__bRpT2W__large",
  "link": "Button-module__bRpT2W__link",
  "medium": "Button-module__bRpT2W__medium",
  "primary": "Button-module__bRpT2W__primary",
  "secondary": "Button-module__bRpT2W__secondary",
  "small": "Button-module__bRpT2W__small",
  "tertiary": "Button-module__bRpT2W__tertiary",
  "uncolored": "Button-module__bRpT2W__uncolored",
});
